<div class="main">
    <div class="main-colour background" [style.background-color]="backgroundColor"
         (click)="backgroundClicked($event)"></div>
    <div class="main-colour foreground" [style.background-color]="foregroundColor"
         (click)="foregroundClicked($event)"></div>
</div>
